import {
  activationEmail,
  resendEmailResetPassword,
} from "services/AuthenticationService";
import { useSnackbar } from "providers/SnackbarProvider";
import { useAppSelector } from "../../store/store";
import { ResendVerifyEmailBtnProps } from "interfaces";
import {
  buttonResend,
  notReceiveEmail,
  snackbarDetailSuccessSendEmail,
  snackbarSeveritySuccess,
  snackbarSummarySuccessSendEmail,
} from "../../_constants";
import { Button } from "primereact/button";

export const ResendVerifyEmailBtn = ({
  isRegisterFlow = true,
}: ResendVerifyEmailBtnProps) => {
  const { showSnackbar } = useSnackbar();
  const email = useAppSelector((state) =>
    isRegisterFlow
      ? state.registerFormSlice.value.email
      : state.resetPasswordFormSlice.value.email
  );

  const resendRegisterEmail = () => {
    const request = {
      email: email,
    };
    activationEmail(request)
      .then(() => {
        showSnackbar({
          severity: snackbarSeveritySuccess,
          summary: snackbarSummarySuccessSendEmail,
          detail: snackbarDetailSuccessSendEmail,
          life: 5000,
        });
      })
      .catch((_) => {});
  };

  const resendResetEmail = () => {
    const request = {
      email: email,
    };
    resendEmailResetPassword(request)
      .then(() => {
        showSnackbar({
          severity: snackbarSeveritySuccess,
          summary: snackbarSummarySuccessSendEmail,
          detail: snackbarDetailSuccessSendEmail,
          life: 5000,
        });
      })
      .catch((_) => {});
  };

  const reinviaEmail = () => {
    isRegisterFlow ? resendRegisterEmail() : resendResetEmail();
  };

  return (
    <div className="height-100 flex-container align-center">
      <p>
        {notReceiveEmail + " "}
        <Button
          link
          label={buttonResend}
          onClick={reinviaEmail}
          className="padd-0"
        />
      </p>
    </div>
  );
};
